import axios from "axios";
import { uri } from "../../../../help/Api";
import { sto } from "../../../../Context/InshData";
import { colors } from "@material-ui/core";
import { data } from "../../../Dashboard/components/LatestSales/chart";

export const localSearch = (newValue, Items) => {
    const search = newValue?.trim().toLowerCase();
    return Items.filter((obj) => obj?.name.toLowerCase().includes(search) ||
        obj?.nameE.toLowerCase().includes(search) || obj?.barcode.toLowerCase().includes(search));
};

export const localSearchCustomer = (newValue, Customers, setSearchCustText) => {
    const search = newValue?.trim().toLowerCase();
    setSearchCustText(newValue);
    return Customers.filter((obj) => obj?.name.toLowerCase().includes(search) || String(obj?.acc_no).toLowerCase().includes(search));
};
export const handleInputSearchCustomers = (newValue, customers, searchTimeout, setOptionsCustomers,
    countCustomers, type, withOmlat, setSearchCustText, reason) => {
    if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
    }
    if (!newValue || newValue.length < 1 || reason !== "input") {
        setOptionsCustomers(customers);
        return;
    }
    searchTimeout.current = setTimeout(async () => {
        const opLocCustomers = localSearchCustomer(newValue, customers, setSearchCustText);
        if (opLocCustomers.length > 0) {
            setOptionsCustomers(opLocCustomers ?? []);
            return;
        } else if (countCustomers) {
            viewHandleCustomers(newValue, setOptionsCustomers, withOmlat, type, -1, customers);
        } else {
            setOptionsCustomers([]);
        }
    }, 500);
};
export const viewHandleCustomers = (newValue, setOptionsCustomers, withOmlat, type, cust_id, customers, setValueCustomers) => {
    const tb = {
        CustomersSearch: true,
        parms: {
            id: type,
            cust_id: cust_id,
            cust_name: newValue,
            tname: "search",
            iempid: sto.empi,
            withOmlat: withOmlat,
            db_name: sto.db_name
        },
    };

    axios
        .post(uri + "Res", tb)
        .then((res) => {
            if (cust_id != -1) {
                setValueCustomers(res.data?.Customers[0]);
                setOptionsCustomers([...res.data?.Customers, ...customers]);
            }
            else { setOptionsCustomers(res.data?.Customers); }
        })
        .catch((error) => {
            setOptionsCustomers([]);
        });
};

export const handleInputSearchItems = (newValue, items, searchTimeout, setOptionsItemsSearch, countItem, IsName, reason) => {
    if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
    }
    if (!newValue || newValue.length < 1 || reason !== "input") {
        setOptionsItemsSearch(items);
        return;
    }
    searchTimeout.current = setTimeout(async () => {
        const opLocItems = localSearch(newValue, items);
        if (opLocItems.length > 0) {
            setOptionsItemsSearch(opLocItems ?? []);
            return;
        } else if (countItem) {
            if (IsName) { viewItemsHandle('', newValue, setOptionsItemsSearch); }
            else { viewItemsHandle(newValue, '', setOptionsItemsSearch); }
        } else {
            setOptionsItemsSearch([]);
        }
    }, 500);
};
export const viewItemsHandle = async (barcode, name, setOptionsItemsSearch) => {
    const code = barcode?.trim().toLowerCase();
    const symbol = name?.trim().toLowerCase();
    let Urls = null;
    if (sto.db_name===""|| sto.db_name===null){
        Urls=`RptSafes/ItemsSearch?currShow=${-1}&&curr_type=${-1}&&groupid=${-1}&&take=${25}
        &&item_code=${code}&&item_name=${symbol}&&emp=${sto.empi}`
    }else{
        Urls=`RptSafes/ItemsSearch?currShow=${-1}&&curr_type=${-1}&&groupid=${-1}&&take=${25}
        &&item_code=${code}&&item_name=${symbol}&&emp=${sto.empi}&&db_name=${sto.db_name}`
    }
    if (name != null) {
        await axios
            .get(
                uri +Urls
            )
            .then((res) => {
                const itemss = res?.data.map((row, i) => {
                    return { ...row, name: row?.symbol, nameE: row?.nameEN, };
                });
                setOptionsItemsSearch([...itemss]);
            })
            .catch((err) => {
                setOptionsItemsSearch([]);
            });
    } else {
    }
};

export const viewItemsHandleInv = async (group_id, fromItem, item_name, rptParams, setFetching, setOptionsItemsSearch, setcuRows) => {
    let nameItem = fromItem ? item_name.toString() : rptParams?.symbol;
    let barcodeItem = fromItem ? '' : rptParams?.barcodeS;
    let group_idItem = fromItem ? null : group_id;
    let numberItem = fromItem ? 25 : 50;
    let Urls = null;
    if (sto.db_name===""|| sto.db_name===null){
        Urls=`RptSafes/ItemsSearch?currShow=${-1}&&curr_type=${-1}&&groupid=${group_idItem}&&take=${numberItem}
        &&item_code=${barcodeItem}&&item_name=${nameItem}&&emp=${sto.empi}`
    }else{
        Urls=`RptSafes/ItemsSearch?currShow=${-1}&&curr_type=${-1}&&groupid=${group_idItem}&&take=${numberItem}
        &&item_code=${barcodeItem}&&item_name=${nameItem}&&emp=${sto.empi}&&db_name=${sto.db_name}`
    }
    if (rptParams.barcodeS == null && group_id == null && rptParams.symbol == null) {

    } else {
        setFetching(true);
        await axios
            .get(
                uri +Urls
            )
            .then((res) => {
                setFetching(false);
                const dataItems = res.data.map((row, i) => {
                    return { ...row, name: row.symbol, nameE: row.nameEN, };
                });
                if (fromItem) { setOptionsItemsSearch(dataItems); }
                else { setcuRows(dataItems); }
            })
            .catch((err) => {
                setFetching(false);
                if (fromItem) setOptionsItemsSearch([]);
                else
                    setcuRows([]);
            });
    }

};


export const viewHandleSearchInv = async (group_id, fromItem, setFildSearch, item_name, stor, rptParams, setFetching,
    setOptionsItemsSearch, setcuRows, setting, valueSafes, take) => {
    let nameItem = fromItem ? item_name.toString() : rptParams?.symbol;
    let barcodeItem = fromItem ? '' : rptParams?.barcodeS;
    let group_idItem = fromItem ? null : group_id;
    let numberItem = fromItem ? 25 : take ? take : 50;

    if (rptParams.barcodeS == null && group_id == null && rptParams.symbol == null) {

    } else {
        if (stor.invsType === 7) {
            let Urls=null;
            if (sto.db_name===""|| sto.db_name===null){
                Urls=`RptSafes/ItemsSearchMake?currShow=${-1}&&curr_type=${-1}&&groupid=${group_idItem}
                &&take=${numberItem}&&item_code=${barcodeItem}&&item_name=${nameItem}&&emp=${sto.empi}`
            }else{
                Urls=`RptSafes/ItemsSearchMake?currShow=${-1}&&curr_type=${-1}&&groupid=${group_idItem}
                &&take=${numberItem}&&item_code=${barcodeItem}&&item_name=${nameItem}&&emp=${sto.empi}&&db_name=${sto.db_name}`
            }
            setFetching(true);
            await axios
                .get(
                    uri +Urls
                )
                .then((res) => {
                    setFetching(false);
                    setFildSearch(false);
                    const dataItems = res.data.map((row, i) => {
                        return { ...row, name: row.symbol, nameE: row.nameEN, };
                    });
                    if (fromItem) { setOptionsItemsSearch(dataItems); }
                    else { setcuRows(dataItems); }
                })
                .catch((err) => {
                    setFetching(false);
                    if (fromItem) setOptionsItemsSearch([]);
                    else
                        setFildSearch(true);
                    setcuRows([]);
                });
        }
        else {
            let Urls=null;
            if (sto.db_name===""|| sto.db_name===null){
                Urls=`RptSafes/ItemsInvSearch?currShow=${-1}&&curr_type=${-1}&&groupid=${group_idItem}&&take=${numberItem}&&item_code=${barcodeItem}
                &&item_name=${nameItem}&&emp=${sto.empi}&&procInvType=${setting.PrTy_InPr}&&safe=${valueSafes.id}`
            }else{
                Urls=`RptSafes/ItemsInvSearch?currShow=${-1}&&curr_type=${-1}&&groupid=${group_idItem}&&take=${numberItem}&&item_code=${barcodeItem}
                &&item_name=${nameItem}&&emp=${sto.empi}&&procInvType=${setting.PrTy_InPr}&&safe=${valueSafes.id}&&db_name=${sto.db_name}`
            }
            setFetching(true);
            await axios
                .get(
                    uri + Urls
                )
                .then((res) => {
                    setFetching(false);
                    setFildSearch(false);
                    const dataItems = res.data.map((row, i) => {
                        return { ...row, name: row.symbol, nameE: row.nameEN, };
                    });
                    if (fromItem) { setOptionsItemsSearch(dataItems); }
                    else { setcuRows(dataItems); }
                })
                .catch((err) => {
                    setFildSearch(true);
                    viewItemsHandleInv(group_id, fromItem, item_name, rptParams, setFetching, setOptionsItemsSearch, setcuRows);
                });
        }
    }
};

export const mathsTotals = (rTotAfterDic, taxperc, ty, withvat) => {
    // if (permiCuCo.CWVat == 0 && taxperc != 0) {
    if (withvat == 0 && taxperc != 0) {
        if (ty === "taxval") return ((rTotAfterDic * taxperc) / 100).toFixed(2);
        if (ty === "Net")
            return (rTotAfterDic + (rTotAfterDic * taxperc) / 100).toFixed(2);
        if (ty === "before_vat") return rTotAfterDic.toFixed(2);
    } else if (withvat == 1 && taxperc != 0) {
        if (ty === "taxval")
            return (
                parseFloat(rTotAfterDic) -
                rTotAfterDic / (1 + taxperc / 100)
            ).toFixed(2);
        if (ty === "Net") return rTotAfterDic.toFixed(2);

        if (ty === "before_vat") return (rTotAfterDic - (rTotAfterDic / ((100 + taxperc) / taxperc))).toFixed(2);

    } else if (taxperc == 0) {
        if (ty === "taxval") return (0).toFixed(2);
        if (ty === "Net")
            return (rTotAfterDic).toFixed(2);
        if (ty === "before_vat") return rTotAfterDic.toFixed(2);
    }
};
export const mathsTab3val = (rTotAfterDic, taxperc, ty) => {
    if (taxperc == 0) {
        return (0).toFixed(2);
    } else {
        return ((rTotAfterDic * taxperc) / 100).toFixed(2);
    }
};

export const getDataItemsNoApi = (dataCode, unitF, setting, permistionInv, valueCustomers, subInfo, setSubInfo,
    invDisc, idata, checked, isdata, setIsData, handSums, isAuto, setItemId,withvat) => {
    setItemId(dataCode.id);
    let Price = 0.0;
    let taxperc = 0.0;
    let diaperc = 0.0;
    let dismount = 0.0;
    let item_id = Number(dataCode.id);
    if (setting.PrTy_InPr === "22") {
        taxperc = 0.0;
        Price = parseFloat(dataCode?.purch_price).toFixed(2);
    } else if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03") {
        Price = permistionInv?.TYPEPRICE === 0 || permistionInv?.TYPEPRICE == null ? parseFloat(dataCode?.sale_price) :
            permistionInv?.TYPEPRICE === 1 ? parseFloat(dataCode?.Distributor_price) : parseFloat(dataCode?.jomla_price);
        taxperc = (parseFloat(dataCode.tax)).toFixed(2);
    }
    else {
        Price = parseFloat(dataCode?.purch_price);
        taxperc = (parseFloat(dataCode.tax)).toFixed(2);
    };
    if (parseFloat(valueCustomers?.disc_perc) > 0) {
        dataCode.discount = valueCustomers?.disc_perc ?? 0;
        dataCode.amount_disc = 0;
    } else if (parseFloat(valueCustomers?.discount) > 0) {
        dataCode.discount = 0;
        dataCode.amount_disc = valueCustomers?.discount ?? 0;
    }
    if (valueCustomers?.WithoutTax > 0 && setting.PrTy_InPr == "01") { taxperc = 0; }
    if (parseFloat(dataCode.amount_disc) > parseFloat(Price)) { dataCode.amount_disc = 0; dataCode.discount = 0; }

    if (setting.PrTy_InPr === "03" || setting.PrTy_InPr === "04" || setting.PrTy_InPr === "22") {
        dataCode.discount = 0;
        dataCode.amount_disc = 0;
    }
    let i = {
        amount_disc: Number(dataCode.amount_disc),
        discount: Number(dataCode.discount),
    };
    diaperc = (parseFloat(i.discount)).toFixed(2);
    dismount = (parseFloat(i.amount_disc)).toFixed(2);
    let totals = parseFloat(Price).toFixed(2);
    let total_after_disc = parseFloat(Price).toFixed(2);
    let total_before_tax = parseFloat(Price).toFixed(2);
    let tax_val = 0.0;
    let net_total = 0.0;
    let total_before_tab3 = 0.0;
    if (permistionInv.DSOB == true) {
        if (checked.discRateck === true) {
            diaperc = parseFloat(invDisc.rate).toFixed(2);
            dismount = (parseFloat(invDisc.rate / 100) * parseFloat(totals)).toFixed(2);
            total_after_disc = (parseFloat(totals) - parseFloat(dismount)).toFixed(2);
        } else if (checked.discMinusck === true) {
            diaperc = ((parseFloat(idata.minus) / parseFloat(totals)) * 100).toFixed(2);
            dismount = (parseFloat(diaperc / 100) * parseFloat(totals)).toFixed(2);
            total_after_disc = (parseFloat(totals) - parseFloat(dismount)).toFixed(2);
        }
    } else {
        if (diaperc > 0) {
            diaperc = parseFloat(diaperc).toFixed(2);
            dismount = (parseFloat(diaperc / 100) * parseFloat(totals)).toFixed(2);
            total_after_disc = (parseFloat(totals) - parseFloat(dismount)).toFixed(2);
        } else if (dismount > 0) {
            diaperc = (parseFloat(dismount * 100) / parseFloat(totals)).toFixed(2);
            dismount = parseFloat(dismount).toFixed(2);
            total_after_disc = (parseFloat(totals) - parseFloat(dismount)).toFixed(2);
        }
    }
    tax_val = mathsTotals(parseFloat(total_after_disc), parseFloat(taxperc), "taxval", withvat);
    total_before_tax = mathsTotals(parseFloat(total_after_disc), parseFloat(taxperc), "before_vat", withvat);
    net_total = mathsTotals(parseFloat(total_after_disc), parseFloat(taxperc), "Net", withvat);

    if (dataCode?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
        total_before_tab3 = (parseFloat(total_before_tax) < parseFloat(25)) ?
            parseFloat(25) : parseFloat(total_before_tax).toFixed(2);
        let tot_before = (parseFloat(total_before_tax) + parseFloat(total_before_tab3)).toFixed(2);
        tax_val = mathsTab3val(parseFloat(tot_before), parseFloat(taxperc), "taxval", withvat);
        net_total = (parseFloat(total_before_tab3) + parseFloat(total_before_tax) + parseFloat(tax_val)).toFixed(2);
    }
    if (isAuto) {
        dataCode = {
            currency_from: parseInt(item_id),
            symbol: dataCode.symbol,
            unitame: unitF.unitName,
            PricePu: dataCode.purch_price,
            minPrice: dataCode.min_sale_price,
            totJust: totals,
            totAfterDisc: total_before_tax,
            tot_before_vat_after_d: total_before_tax,
            sale_price: parseFloat(dataCode?.sale_price),
            tab3val_sub: total_before_tab3,
            tab3Val: total_before_tab3,
            unit: parseInt(dataCode.unit),
            val1: parseFloat(1),
            val: parseFloat(1),
            new_exchange_price: parseFloat(Price),
            discount: dismount,
            DiscPers: diaperc,
            taxperc: parseFloat(taxperc),
            taxval: parseFloat(tax_val),
            netAmountSub: parseFloat(net_total).toFixed(2),
            barcode: dataCode.barcode.toString(),
            sub_center: 0,
            sub_branch: sto.branchi,
            Qtys: 0,
            UnitsTable: dataCode.units,
            defUnit: unitF,
            no: isdata?.length,
            editAbleVal: false,
            editAblePrice: false,
            editAbleUnit: false,
            editAbleTax: false,
            editAbleDescM: false,
            editAbleDescP: false,
            editAbleDescNote: false,
            type: dataCode.type,
        }
        if (permistionInv?.NOREP === true) {
            let dataToAdd = [...isdata];
            dataToAdd.push(dataCode);
            setIsData(dataToAdd);
            handSums(dataToAdd);
            // setExSub(dataToAdd.length);
        } else {
            const updateItem = isdata.find((obj) => obj.barcode.toString() === dataCode.barcode.toString()
                && obj.new_exchange_price === dataCode.new_exchange_price);
            if (updateItem?.no != null) {
                let add = 1;
                let multiplier = (parseFloat(updateItem?.val1) + parseFloat(add)).toFixed(2);
                if (!isNaN(multiplier)) {

                    let tot = parseFloat(multiplier * updateItem.new_exchange_price);
                    let desc_mount = (
                        parseFloat(tot) *
                        (updateItem.DiscPers / 100)
                    );
                    let totBe = parseFloat((multiplier * updateItem.new_exchange_price) - desc_mount);

                    let taxMount = mathsTotals(
                        parseFloat(totBe),
                        parseFloat(updateItem.taxperc),
                        "taxval", withvat,
                    );
                    let betTax = mathsTotals(
                        parseFloat(totBe),
                        parseFloat(updateItem.taxperc),
                        "before_vat", withvat
                    );

                    let resNetA = mathsTotals(
                        parseFloat(totBe),
                        parseFloat(updateItem.taxperc),
                        "Net", withvat
                    );

                    if (parseFloat(updateItem?.tab3val_sub) > 0) {
                        let tot_before_new = mathsTotals(
                            parseFloat(Price),
                            parseFloat(updateItem.taxperc),
                            "before_vat", withvat
                        );
                        total_before_tab3 = (parseFloat(tot_before_new) < parseFloat(25)) ?
                            (parseFloat(25) * multiplier) : parseFloat(betTax).toFixed(2);

                        let tot_before = (parseFloat(betTax) + parseFloat(total_before_tab3)).toFixed(2);

                        taxMount = mathsTab3val(
                            parseFloat(tot_before),
                            parseFloat(updateItem.taxperc),
                            "taxval"
                        );

                        resNetA = (parseFloat(total_before_tab3) + parseFloat(betTax)
                            + parseFloat(taxMount)).toFixed(2);
                    }
                    const newData = {
                        ...updateItem,
                        val1: multiplier,
                        totJust: tot,
                        totAfterDisc: betTax,
                        taxval: taxMount,
                        netAmountSub: resNetA,
                        discount: desc_mount,
                        tab3val_sub: total_before_tab3,
                        tab3Val: total_before_tab3,
                    };

                    const index = updateItem?.no;
                    const dataUpdate = [...isdata];
                    dataUpdate[index] = { ...newData };
                    setIsData([...dataUpdate]);
                    handSums(dataUpdate);
                }
            } else {
                let dataToAdd = [...isdata];
                dataToAdd.push(dataCode);
                setIsData(dataToAdd);
                handSums(dataToAdd);
                // setExSub(dataToAdd.length);
            }
        }
    } else {
        setSubInfo({
            ...subInfo,
            val1: 1,
            is_tab3_curr: dataCode?.is_tab3_curr,
            id: parseInt(item_id),
            minPrice: dataCode.min_sale_price,
            Price: parseFloat(Price).toFixed(2),
            val: 1, val1: 1,
            barcode: dataCode.barcode,
            symbol: dataCode.symbol,
            type: dataCode.type,
            perc: 1,
            taxperc: taxperc,
            totJust: parseFloat(Price).toFixed(2),
            discount: dismount,
            DiscPers: diaperc,
            taxval: parseFloat(tax_val),
            unitame: unitF.unitName,
            jPrice: parseFloat(dataCode.jomla_price),
            dPrice: parseFloat(dataCode.Distributor_price),
            salePrice: parseFloat(dataCode.sale_price),
            sale_price: parseFloat(dataCode.sale_price),
            PricePu: parseFloat(dataCode.purch_price),
            UnitsTable: dataCode.units,
            defUnit: unitF,
            no: isdata?.length,
            Qtys: Number(0),
        });
    }

};

export const addArchaiveFile = async (file, fileName) => {

    const formData = new FormData();
    if (file) {
        formData.append("file", file);
    }
    formData.append("FileName", fileName);

    try {
        const response = await axios.post(
            `${uri}templates/archaive`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        console.log("Template added successfully", response.data);

    } catch (error) {
        console.error("Error saving template", error);
    }
};

export const addMultiArchaiveFile = async (files, fileName) => {

    const formData = new FormData();
    // if (file) {
    //     formData.append("file", file);
    // }
    files.forEach((file,index)=>{
        const extention=file.name.substring(file.name.lastIndexOf("."));
        const newName=
         `${fileName}${String(index+1).padStart(2,"0")}${extention}`;

         const renameFile=new File(
            [file],
            newName,
            {
                type:file.type,
                lastModified:file.lastModified,
            }
         );
         formData.append("files", renameFile);
    });


    try {
        const response = await axios.post(
            `${uri}templates/archaivemulti`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        console.log("Template added successfully", response.data);

    } catch (error) {
        console.error("Error saving template", error);
    }
};


export const handleDownloadFiles = async (fileName) => {
    try {

        const response = await axios.get(
            `${uri}templates/download-archaive/${fileName}`,
            {
                responseType: "arraybuffer",
            }
        );

        const mimeType = "application/octet-stream";
        const blob = new Blob([response.data], { type: mimeType });
        const contentDisposition = response.headers["content-disposition"];
        let originalName = "";
        console.log("the contentDisposition is", contentDisposition)

        if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/);
            if (match) {
                originalName = match[1];
            }
        }
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = originalName;
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        console.error("Error downloading file", error);
    }
};

export const handleMultiDownloadFiles = async (prefix) => {
    try {

        const response = await axios.get(
            `${uri}templates/download-archaives`,
            {
                params:{
                    prefix,
                }
            }
        );

        const files=response.data;
        files.forEach((fileName)=>{
            handleDownloadFiles(encodeURIComponent(fileName));
        });

    } catch (error) {
        console.error("Error downloading file", error);
    }
};

export const menuBottonsFile = (handleClickOutLine, openFileDialog, handleDownload, menPostion, fileInputRef, handleFileSelect) => {
    return (
        <ul
            style={{
                position: "absolute",
                top: menPostion.y,
                left: menPostion.x,
                background: "white",
                border: "1px solid #ccc",
                borderRadius: "8px",
                listStyle: "none",
                padding: "5px 0",
                boxShadow: "0px 2px 6px rgba(0,0,0,0.3)",
                width: "150px"
            }}
        >
            <li
                style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    borderBottom: "1px solid #eee"
                }}
                onClick={(e) => {
                    openFileDialog();
                }}

            >
                {"Add File"}
            </li>
            <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileSelect} />
            <li
                style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    borderBottom: "1px solid #eee"
                }}
                onClick={(e) => {
                    handleDownload();
                }}
            >
                {"DownLoad File"}
            </li>
            <li
                style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    borderBottom: "1px solid #eee",
                    color: colors.red[700],
                }}
                onClick={(e) => {
                    handleClickOutLine(e);
                }}
            >
                {"Cancel"}
            </li>
        </ul>
    );
};

export const menuBottonsMultiFile = (handleClickOutLine, openFileDialog, handleDownload, menPostion, fileInputRef, handleMultiFilesSelect) => {
    return (
        <ul
            style={{
                position: "absolute",
                top: menPostion.y,
                left: menPostion.x,
                background: "white",
                border: "1px solid #ccc",
                borderRadius: "8px",
                listStyle: "none",
                padding: "5px 0",
                boxShadow: "0px 2px 6px rgba(0,0,0,0.3)",
                width: "150px"
            }}
        >
            <li
                style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    borderBottom: "1px solid #eee"
                }}
                onClick={(e) => {
                    openFileDialog();
                }}

            >
                {"Add File"}
            </li>
            <input
                type="file"
                ref={fileInputRef}
                multiple
                style={{ display: "none" }}
                onChange={handleMultiFilesSelect} />
            <li
                style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    borderBottom: "1px solid #eee"
                }}
                onClick={(e) => {
                    handleDownload();
                }}
            >
                {"DownLoad File"}
            </li>
            <li
                style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    borderBottom: "1px solid #eee",
                    color: colors.red[700],
                }}
                onClick={(e) => {
                    handleClickOutLine(e);
                }}
            >
                {"Cancel"}
            </li>
        </ul>
    );
};
